import { ElementWithCodeAndValue } from '@playbooks/core/src/interfaces/ActionCard'

import getResult from './getResult'
import { useTranslation } from '../contexts/localization/Localization'

/**
 * Process '$...' replacements in the given text using the provided Action Card elements values.
 * @param text Text to process
 * @param translation Translator function
 * @param elementsWithCode Array of elements with codes to replace in the text
 * @param useBrackets useBrackets boolean, if the value must be in brackets
 * @param skipElementTypes An array of element types to skip during processing.
 * @returns Processed text
 */
export function processReplacements(
  text: string | null,
  elementsWithCode: ElementWithCodeAndValue[],
  useBrackets: boolean = true,
  skipElementTypes: string[] = [],
) {
  const translation = useTranslation.text

  elementsWithCode.forEach(element => {
    if (skipElementTypes.includes(element.type)) {
      return
    }

    const res = getResult(element, translation, useBrackets)
    text = text?.replaceAll(`$${element.code}`, res) || null
  })

  return text
}
